export var BadgeVariant;
(function (BadgeVariant) {
    BadgeVariant["SUCCESS"] = "SUCCESS";
    BadgeVariant["INFO"] = "INFO";
    BadgeVariant["WARNING"] = "WARNING";
    BadgeVariant["ERROR"] = "ERROR";
    BadgeVariant["MAIN"] = "MAIN";
    BadgeVariant["ACCENT"] = "ACCENT";
})(BadgeVariant || (BadgeVariant = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFkZ2VQcm9wcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2NvbXBvbmVudHMvYmFkZ2UvQmFkZ2VQcm9wcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrQkEsTUFBTSxDQUFOLElBQVksWUFPWDtBQVBELFdBQVksWUFBWTtJQUN0QixtQ0FBbUIsQ0FBQTtJQUNuQiw2QkFBYSxDQUFBO0lBQ2IsbUNBQW1CLENBQUE7SUFDbkIsK0JBQWUsQ0FBQTtJQUNmLDZCQUFhLENBQUE7SUFDYixpQ0FBaUIsQ0FBQTtBQUNuQixDQUFDLEVBUFcsWUFBWSxLQUFaLFlBQVksUUFPdkIifQ==